const SvgSupplyChain2 = (props) => (
  <>
    <path
      d="M140 96c0-2.18 1.75-3.95 3.92-3.99-1.91-23.4-20.54-42.05-43.93-43.99 0 2.2-1.79 3.98-4 3.98s-3.99-1.79-4-3.99C68.57 49.92 49.89 68.58 47.98 92h.01c2.21 0 4 1.79 4 4s-1.79 4-4 4c1.94 23.4 20.6 42.05 44.01 43.95.03-2.19 1.8-3.95 4-3.95s3.96 1.76 3.99 3.94c23.37-1.94 42-20.57 43.93-43.95A3.993 3.993 0 0 1 140 96Z"
      fill="none"
    />
    <path
      d="M188 96c0-2.18 1.74-3.94 3.91-3.99C189.87 42.17 149.83 2.13 99.99.09a3.991 3.991 0 0 1-7.98 0C42.17 2.13 2.13 42.17.09 92.01a3.991 3.991 0 0 1 0 7.98c2.04 49.84 42.08 89.88 91.92 91.92a3.991 3.991 0 0 1 7.98 0c49.84-2.04 89.88-42.08 91.92-91.92A3.991 3.991 0 0 1 188 96Zm-44 4h-.08c-1.93 23.38-20.55 42.01-43.93 43.95v.06c0 2.21-1.79 4-4 4s-4-1.79-4-4v-.05c-23.41-1.9-42.08-20.55-44.01-43.95-2.21 0-3.99-1.79-3.99-4s1.78-3.99 3.99-4c1.92-23.42 20.59-42.08 44.01-43.99 0-2.21 1.79-4 4-4s4 1.79 4 4v.02c23.39 1.95 42.01 20.6 43.93 43.99h.08c2.21 0 4 1.79 4 4s-1.79 4-4 4Z"
      fill={props.p20}
      stroke={props.p30}
      strokeLinejoin="round"
    />
    <path
      d="M99.99.09V0c0-2.21-1.79-4-4-4s-4 1.79-4 4v.09M92 48.01c0 2.2 1.79 3.99 4 3.99s3.99-1.78 4-3.98M99.99 143.94c-.03-2.18-1.8-3.94-3.99-3.94s-3.97 1.76-4 3.95"
      fill="none"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <path
      d="M92.01 191.91v.09c0 2.21 1.79 4 4 4s4-1.79 4-4v-.09"
      fill="#fff"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
    <path
      d="M.09 92.01H0c-2.21 0-4 1.79-4 4s1.79 4 4 4h.09M47.99 100c2.21 0 4-1.79 4-4s-1.79-4-4-4h-.01M143.92 92.01c-2.17.04-3.92 1.81-3.92 3.99s1.75 3.95 3.92 3.99M191.91 99.99h.09c2.21 0 4-1.79 4-4s-1.79-4-4-4h-.09"
      fill="none"
      stroke={props.p30}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgSupplyChain2;
